import { z } from 'zod';
export const NAMESPACES = [
    'studies',
    'study-groups',
    'chat',
    'prefs',
    'bookmarks',
    'notes',
    'prayer',
    'history',
    'memory',
    'backups',
];
export const NamespaceSchema = z.enum(NAMESPACES);
export function isBlobNamespace(ns) {
    return ns === 'backups';
}
//# sourceMappingURL=namespaces.js.map